import { useState, useEffect } from 'react';
import { teamEditService } from '../services/teamEdit.service';
import type { EditReferenceData, TeamEditFormValues } from '../types/teamEdit.types';
import { useAuth } from '@/core/auth/AuthContext';

export function useTeamEdit(companyId: string, id: string) {
  const { user } = useAuth();
  const userId = user?.id || '';
  
  const [referenceData, setReferenceData] = useState<EditReferenceData>({ projects: [], users: [] });
  const [initialData, setInitialData] = useState<TeamEditFormValues | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    async function load() {
      if (!companyId || !id || !userId) return;
      try {
        const [ref, team] = await Promise.all([
          teamEditService.getReferenceData(companyId, userId),
          teamEditService.getTeam(id, userId)
        ]);
        setReferenceData(ref);
        setInitialData(team);
      } catch (err) {
        console.error('[useTeamEdit] Error loading data:', err);
      } finally {
        setIsLoading(false);
      }
    }
    load();
  }, [companyId, id, userId]);

  const updateTeam = async (values: Partial<TeamEditFormValues>) => {
    if (!userId) return;
    setIsSubmitting(true);
    try {
      const res = await teamEditService.updateTeam(id, values, userId);
      return res;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    referenceData,
    initialData,
    isLoading,
    isSubmitting,
    updateTeam
  };
}
